import { useNavigate } from 'react-router-dom';
import { useAuth } from 'hooks';
import { AuthRole } from 'common/enums/enums';
import { ReactNode, useLayoutEffect } from 'react';
import { defaultAppRoutes } from 'common/utils/defaultAppRoutes';

export type RolesGuardProps = {
  allowedRoles?: AuthRole[];
  notAllowedRoles?: AuthRole[];
  children?: ReactNode;
};

const RolesGuard = ({ children, notAllowedRoles }: RolesGuardProps) => {
  const { isAuthenticated, user } = useAuth();
  const navigate = useNavigate();
  
  const activeRole = user?.activeRole;
  const haveDeniedRoles = Boolean(
    isAuthenticated && 
    activeRole && 
    notAllowedRoles?.includes(activeRole)
  );

  useLayoutEffect(() => {
    if (isAuthenticated && haveDeniedRoles && activeRole) {
      const defaultRoute = defaultAppRoutes([activeRole]);
      navigate(defaultRoute, { replace: true });
    }
  }, [isAuthenticated, haveDeniedRoles, activeRole, navigate]);

  return <>{children}</>;
};

export { RolesGuard };
